
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3120_55237)","stroke":"#293343","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.406 14.229h-9.5a1.5 1.5 0 110-3h8.5a1 1 0 001-1v-8a1 1 0 00-1-1h-8.5a1.5 1.5 0 00-1.5 1.46v10M12.406 11.229v3"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3120_55237"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.906 .69)","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    